import { ICellRendererComp, ICellRendererParams } from '@ag-grid-community/core';
import { HIGHLIGHT_AMBER_BG, HIGHLIGHT_AMBER_COLOR } from '../../../styles';

export class OfferingTypeRenderer implements ICellRendererComp {
  params: ICellRendererParams;

  eGui: HTMLElement;

  init(params: ICellRendererParams) {
    this.params = params;
    this.eGui = document.createElement('div');
    this.eGui.style.display = 'flex';
    this.eGui.style.width = '100%';
    this.eGui.style.height = '100%';
    this.eGui.style.alignItems = 'center';
    this.eGui.style.justifyContent = 'center';
    const div = document.createElement('div');
    div.style.height = '20px';
    div.style.width = '20px';
    div.style.borderRadius = '10px';
    div.style.display = 'flex';
    div.style.alignItems = 'center';
    div.style.justifyContent = 'center';
    switch (params.value) {
      case 'Negotiated':
        div.innerText = 'N';
        div.style.color = '#3785fb';
        div.style.background = 'rgba(55, 133, 251, 0.2)';
        break;

      case 'Competitive':
        div.innerText = 'C';
        div.style.color = HIGHLIGHT_AMBER_COLOR;
        div.style.background = HIGHLIGHT_AMBER_BG;
        break;
    }
    this.eGui.append(div);
  }

  getGui() {
    return this.eGui;
  }

  refresh() {
    return true;
  }
}
